import React from 'react';
import {TextField } from '@material-ui/core';

const AddSecureText = ({formData, setFormData}) => { 
    return ( 
      <div>  
            <div>Frase de Segurança</div>
            <textarea 
               style={{width: "95%",
                height: "151px",
                marginTop: "16px",
                marginBottom: "16px",
                padding: "6px"}}

                value={formData?.text_box}
               onChange={(e) => setFormData({ ...formData, text_box: e.target.value })}
            ></textarea>

            <br />
            <div>Descrição</div>
            <input 
            style={{width: "96%",
                marginTop: "15px",
                padding: "7px"}}
                value={formData?.description || ''}
                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
            />
        </div>  
    );
};

export default AddSecureText;


